module.exports = __webpack_public_path__ + "img/iran.6bb97bbd.svg";